import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Col, Row, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import Table from "react-bootstrap/Table";

import { toast } from "react-toastify";
import CompanyAdminResumeAutoOlt from "../companyAdmin/CompanyAdminResumeAutoOlt";

const CompanyAdminResumeAutoOLTModal: React.FC<ResumeOLTCreationModalProp> = ({
  handleClose,
  show,
  intPkCompanyID,
  companyName,
  intPkOltID,
}) => {
  const handleApiResponse = (isSuccess: boolean) => {
    console.log({ isSuccess });
    if (isSuccess === true) {
      handleClose(true);
    }
  };
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        show={show}
        onHide={() => {
          handleClose(false);
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Resume OLT Process</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CompanyAdminResumeAutoOlt
            companyName={companyName}
            intPkCompanyID={intPkCompanyID}
            handleApiResponse={handleApiResponse}
            intPkOltID={intPkOltID}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              handleClose(false);
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default CompanyAdminResumeAutoOLTModal;
